<template>
  <span class="ai-bot" :aria-busy="working ? 'true' : 'false'">
    <svg width="34" height="36" viewBox="0 0 38 40" aria-hidden="true" focusable="false">
      <path d="M19 9V5" stroke="#a72a65" stroke-width="2" />
      <circle cx="19" cy="4" r="3" fill="#ed1764" />
      <rect x="6" y="10" width="26" height="21" rx="8" fill="#fff0f6" stroke="#a72a65" stroke-width="2" />
      <path d="M3 18v6M35 18v6M12 33v4M26 33v4" stroke="#a72a65" stroke-width="3" stroke-linecap="round" />
      <circle cx="13" cy="19" r="2.5" fill="#4a235a" />
      <circle cx="25" cy="19" r="2.5" fill="#4a235a" />
      <path d="M15 25q4 4 8 0" fill="none" stroke="#a72a65" stroke-width="2" stroke-linecap="round" />
      <circle cx="10" cy="24" r="2" fill="#f8b6d1" />
      <circle cx="28" cy="24" r="2" fill="#f8b6d1" />
    </svg>
    <span v-if="working" class="ai-bot-spinner" role="status" aria-label="הבוט עובד" />
  </span>
</template>

<script>
export default {
  name: 'AiBot',
  props: { working: Boolean }
}
</script>

<style scoped>
.ai-bot { display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0; }
.ai-bot-spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #f8d3e3;
  border-top-color: #ed1764;
  border-radius: 50%;
  animation: ai-bot-spin 0.8s linear infinite;
}
@keyframes ai-bot-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .ai-bot-spinner { animation-duration: 2.4s; } }
</style>
